export default __webpack_public_path__ + "static/media/login_logo.d7078415.png";